const button = {
    cancel: 'Annuler',
    ok: 'OK',

    no: 'Non',
    yes: 'Oui',
};

export default button;
